import { render } from "./BarStackedChart.vue?vue&type=template&id=bf375d24"
import script from "./BarStackedChart.vue?vue&type=script&lang=js"
export * from "./BarStackedChart.vue?vue&type=script&lang=js"

import "./BarStackedChart.vue?vue&type=style&index=0&id=bf375d24&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__